import { useState, useEffect } from "react";
import { getFileInfo } from "services";

const useGetFileInfo = (type) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const doRequest = async () => {
      setIsLoading(true);

      const response = await getFileInfo(type);

      setData(response);

      setIsLoading(false);
    };

    doRequest();
  }, [type]);

  return { data, isLoading };
};

export { useGetFileInfo };
